import { useCallback } from 'react';
import { currenciesService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Currency } from '../types';

export function useCurrencies(
  options?: ResourceQueryOptions
): ResourceState<Currency> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      currenciesService.getAll(opts) as unknown as Promise<{ data: Currency[]; meta?: any }>,
    []
  );
  return useResourceCollection<Currency>(fetchFn, options);
}

export function useCurrency(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Currency> {
  const resourceId = id;
  const fetchFn = useCallback(
    (currencyId: string | number, opts?: ResourceQueryOptions) =>
      currenciesService.getById(currencyId, opts) as unknown as Promise<Currency>,
    []
  );
  return useResourceById<Currency>(fetchFn, resourceId, options);
}

export function useCreateCurrency(
  onSuccess?: (data: Currency) => void
): MutationState<Currency> {
  const createFn = useCallback(
    (data: any) => currenciesService.create(data) as unknown as Promise<Currency>,
    []
  );
  return useCreateResource<Currency>(createFn, onSuccess);
}

export function useUpdateCurrency(
  onSuccess?: (data: Currency) => void
): MutationState<Currency> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return currenciesService.update(id, data) as unknown as Promise<Currency>;
    },
    []
  );
  return useUpdateResource<Currency>(updateFn, onSuccess);
}

/**
 * Delete currency using documentId
 * @param data - Full currency object containing documentId
 */
export function useDeleteCurrency(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return currenciesService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
